import React from 'react';
import * as THREE from 'three';
import { createRoot } from 'react-dom/client';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, OrthographicCamera } from '@react-three/drei';
import { Physics } from '@react-three/rapier';
import { Game } from './game/board/game';
// import { Bloom, EffectComposer, Noise, Pixelation } from '@react-three/postprocessing';

function App() {
  return (
    <div id="canvas-container">
      <Canvas
        flat
        shadows
        onCreated={({ gl }) => {
          gl.shadowMap.type = THREE.PCFSoftShadowMap;
          gl.outputColorSpace = THREE.SRGBColorSpace;
        }}
        gl={{
          antialias: true,
        }}
        style={{ backgroundColor: '#112233' }}
      >
        {/* Camera */}
        <OrthographicCamera makeDefault position={[0, 0, 20]} zoom={50} near={0} />

        {/* Light */}
        <directionalLight
          position={[15, 20, 5]}
          intensity={1}
          castShadow
          shadow-mapSize-width={2048} // Increase shadow map resolution (default is 512)
          shadow-mapSize-height={2048}
          shadow-radius={8}
        />
        <hemisphereLight intensity={2} />

        {/* <OrbitControls /> */}

        <Physics gravity={[0, -9.81, 0]}>
          <Game />
        </Physics>
      </Canvas>
    </div>
  );
}

const root = document.getElementById('react-root');
if (!root) {
  throw new Error('React root element not found');
}

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
